import { storeLogoQuery } from "../../graphql/storeLogo.gql";
import Search from "../search";
import ActionIcons from "./ActionIcons";
import HeaderLogo from "./HeaderLogo";
import SearchBox from "./SearchBox";

export default function MiddleNavbar({ storeLogo }: storeLogoQuery) {
  return (
    <div className="bg-white h-24 w-full hidden 992:block">
      <div className="flex items-center h-full max-w-970 1300:max-w-1300 justify-between mx-auto">
        <HeaderLogo storeLogo={storeLogo} />
        <Search />
        <ActionIcons />
      </div>
    </div>
  )
}